import React from 'react';

import RejectGift from '@/components/Messanger/Chat/ClaimGiftPopup/components/RejectGift.tsx';
import AcceptGift from '@/components/Messanger/Chat/ClaimGiftPopup/components/AcceptGift.tsx';

interface PendingGiftActionsProps {
  contactId: string;
  contactName?: string;
  onGiftAccepted: () => void;
}

const PendingGiftBottomBar: React.FC<PendingGiftActionsProps> = ({
  contactId,
  contactName,
  onGiftAccepted
}) => {
  return (
    <>
      <RejectGift contactId={contactId} contactName={contactName} />
      <AcceptGift contactId={contactId} onGiftAccepted={onGiftAccepted} />
    </>
  );
};

export default PendingGiftBottomBar;
